import { Flex } from 'antd';

import { HrmRequestFormResponse } from '@Types/api/form';
import { MAvatar, Status } from '@Components/Base';
import { TypeDict, User } from '@Types/index';
import { parseDateTime } from '@Utils/transformDateTime';
import { transformFlagsToOption } from '@Utils/transformToOptions';
import { EMPTY_FIELD_PLACEHOLDER } from '@Constants';
import { ReactComponent as Attachment } from '@Icons/additional/attachment.svg';
import styles from './view-form.module.css';

const fieldSource = (
  data: HrmRequestFormResponse,
  findLeaveType: (requestTypeID: number) => TypeDict | undefined,
  findStatus: (statusNum: number) => TypeDict | undefined,
  documentId: string,
  users: User[],
  userPhoto: string | undefined,
  replacementUser: User | undefined,
  handleDownloadClick: () => void
): Array<{ label: string; value: string | number | boolean | JSX.Element }> => {
  const {
    leaveTypeID,
    startDate,
    endDate,
    totDays,
    filepath,
    ticketRequired,
    passportRequired,
    telephone,
    reqStatusId,
  } = data;

  const replacementEmpName = replacementUser?.empName;
  const matchedStatus = findStatus(reqStatusId)?.codeDesc;
  const matchedLeaveType = findLeaveType(leaveTypeID)?.codeDesc;
  const isPassportRequired = transformFlagsToOption(
    Boolean(passportRequired)
  ).label;
  const isTicketRequired = transformFlagsToOption(
    Boolean(ticketRequired)
  ).label;

  const documenEl = documentId ? (
    <div className={styles.viewItemValueDocument}>
      <Attachment />
      <div className={styles.linkDownload} onClick={handleDownloadClick}>
        {filepath}
      </div>
    </div>
  ) : (
    'No attachments'
  );

  const replacementEmpEl = (
    <Flex align="center">
      <MAvatar size={24} src={userPhoto} style={{ marginRight: '8px' }} />
      <span>{replacementEmpName || ''}</span>
    </Flex>
  );

  const source = {
    Status: <Status text={matchedStatus || ''} />,
    'Leave Type': matchedLeaveType || '',
    'Start Date': parseDateTime(startDate),
    'End Date': parseDateTime(endDate),
    'Total No. of Days': totDays,
    Document: documenEl,
    'Ticket Reimbursement Required': isTicketRequired,
    'Passport Required': isPassportRequired,
    'Home Country Contact Number': telephone || EMPTY_FIELD_PLACEHOLDER,
    'Replacement Employee': replacementEmpEl,
  };

  return Object.entries(source).map((item) => ({
    label: item[0],
    value: item[1],
  }));
};

export default fieldSource;
